import React from 'react';

const SvgCloseCircle = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle opacity="0.2" cx="12" cy="12" r="12" fill="#222222" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.2916 6.29289C16.6821 5.90237 17.3153 5.90237 17.7058 6.29289C18.0963 6.68342 18.0963 7.31658 17.7058 7.70711L13.4147 11.9982L17.7082 16.2916C18.0987 16.6821 18.0987 17.3153 17.7082 17.7058C17.3176 18.0963 16.6845 18.0963 16.294 17.7058L12.0005 13.4124L7.70711 17.7058C7.31658 18.0963 6.68342 18.0963 6.29289 17.7058C5.90237 17.3153 5.90237 16.6821 6.29289 16.2916L10.5863 11.9982L6.29527 7.70711C5.90475 7.31658 5.90475 6.68342 6.29527 6.29289C6.68579 5.90237 7.31896 5.90237 7.70948 6.29289L12.0005 10.5839L16.2916 6.29289Z"
      fill="white"
    />
  </svg>
);

SvgCloseCircle.type = 'monochrome';
export default SvgCloseCircle;
